import { SaveFilterState } from "x/records/list/types";

export const isOkLabel = (saveFilterState: SaveFilterState) => {
  switch (saveFilterState) {
    case "new":
    case "edit":
      return _("Save");
    case "update":
      return _("Update");
  }
};

export const getTitle = (saveFilterState: SaveFilterState) => {
  switch (saveFilterState) {
    case "new":
      return _("Save new view");
    case "edit":
      return _("Edit current view");
    case "update":
      return _("Update current view");
  }
};
